import { RouteInputs } from './RouteInputs'

export default RouteInputs
